<template>
  <div>
    <div class="d-flex justify-center">
      <div class="_temp_list">
        <div class="pa-1">
          <v-card class="rounded_max mb-2" elevation="1">
            <div>
              <div class="d-flex justify-space-between px-2">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      @click="$router.go(-1)"
                      icon
                      ><v-icon>mdi-reply</v-icon></v-btn
                    >
                  </template>
                  <span>Back</span>
                </v-tooltip>
              </div>
              <h3 style="text-align: center" class="mb-2">
                Managing TSA Proposal
              </h3>
            </div>
            <v-tabs centered color="green" slider-size="4" v-model="tab">
              <v-tab class="text-capitalize"> <b>Response</b> </v-tab>
              <v-tab class="text-capitalize"> <b>Guideline</b> </v-tab>
            </v-tabs>
          </v-card>
        </div>
        <v-tabs-items v-model="tab" style="background: none">
          <v-tab-item class="pa-1">
            <tsa-response />
          </v-tab-item>
          <v-tab-item class="pa-1">
            <div class="mt-2">
              <h4>Category</h4>
              <v-select
                class="my-2 rounded-lg"
                dense
                :items="optTypeEvent"
                item-text="name"
                item-value="id"
                v-model="category"
                placeholder="Choose your Type Event"
                flat
                hide-details
                color="green"
                solo
                @change="fetchDataCover"
              ></v-select>
            </div>
            <!-- ===========================================CONTENT -->
            <div
              class="d-flex justify-end mb-2"
              v-if="permissions.includes('UPCM')"
            >
              <v-btn color="var(--g)" dark v-if="!isEdit" @click="isEdit = true"
                >Update</v-btn
              >
              <v-btn color="var(--g)" dark v-if="isEdit" @click="updateData()"
                >Save</v-btn
              >
            </div>
            <v-card
              v-if="!loading && dataSetCover"
              flat
              class="rounded_max pa-4"
              style="overflow: hidden"
            >
              <div class="mb-3">
                <h4>Link Guideline Cover Letter</h4>
                <h5 class="mb-1" style="font-weight: normal">
                  Link Guideline Cover Letter
                </h5>
                <v-textarea
                  v-if="isEdit"
                  class="rounded-lg"
                  auto-grow
                  outlined
                  rows="2"
                  hide-details
                  dense
                  placeholder="Put the link here"
                  v-model="dataSetCover.link_guideline_letter"
                ></v-textarea>
                <v-card flat outlined class="rounded-lg" v-if="!isEdit">
                  <div class="d-flex align-center justify-start">
                    <v-card
                      class="pa-3 rounded-lg d-flex justify-center align-center"
                      color="#757575"
                      flat
                      dark
                    >
                      <v-icon large>mdi-link-variant</v-icon>
                    </v-card>
                    <div class="ml-2" style="width: 85%">
                      <a
                        v-if="dataSetCover.link_guideline_letter"
                        :href="dataSetCover.link_guideline_letter"
                        target="_blank"
                      >
                        <h5 style="width: 100%">
                          {{ dataSetCover.link_guideline_letter }}
                        </h5>
                      </a>
                      <h5 v-else>
                        The link is not yet available, please update it
                      </h5>
                    </div>
                  </div>
                </v-card>
              </div>
              <!-- <div class="mb-3">
                <h4>Link for Cover Letter</h4>
                <h5 class="mb-1" style="font-weight: normal">Link JOTFORM</h5>
                <v-textarea
                  v-if="isEdit"
                  class="rounded-lg"
                  auto-grow
                  outlined
                  rows="2"
                  hide-details
                  dense
                  placeholder="Put the link here"
                  v-model="dataSetCover.link_form_letter"
                ></v-textarea>
                <v-card flat outlined class="rounded-lg" v-if="!isEdit">
                  <div class="d-flex align-center justify-start">
                    <v-card
                      class="pa-3 rounded-lg d-flex justify-center align-center"
                      color="#757575"
                      flat
                      dark
                    >
                      <v-icon large>mdi-link-variant</v-icon>
                    </v-card>
                    <div class="ml-2" style="width: 85%">
                      <a
                        v-if="dataSetCover.link_form_letter"
                        :href="dataSetCover.link_form_letter"
                        target="_blank"
                      >
                        <h5 style="width: 100%">
                          {{ dataSetCover.link_form_letter }}
                        </h5>
                      </a>
                      <h5 v-else>
                        The link is not yet available, please update it
                      </h5>
                    </div>
                  </div>
                </v-card>
              </div> -->
            </v-card>
            <v-card
              v-if="!loading && dataSetCover"
              flat
              class="mt-5 rounded_max pa-4"
              style="overflow: hidden"
            >
              <div class="mb-3">
                <h4>Link Guideline Proposal</h4>
                <h5 class="mb-1" style="font-weight: normal">
                  Link Guideline Proposal
                </h5>
                <v-textarea
                  v-if="isEdit"
                  class="rounded-lg"
                  auto-grow
                  outlined
                  rows="2"
                  hide-details
                  dense
                  placeholder="Put the link here"
                  v-model="dataSetCover.link_guideline_proposal"
                ></v-textarea>
                <v-card flat outlined class="rounded-lg" v-if="!isEdit">
                  <div class="d-flex align-center justify-start">
                    <v-card
                      class="pa-3 rounded-lg d-flex justify-center align-center"
                      color="#757575"
                      flat
                      dark
                    >
                      <v-icon large>mdi-link-variant</v-icon>
                    </v-card>
                    <div class="ml-2" style="width: 85%">
                      <a
                        v-if="dataSetCover.link_guideline_proposal"
                        :href="dataSetCover.link_guideline_proposal"
                        target="_blank"
                      >
                        <h5 style="width: 100%">
                          {{ dataSetCover.link_guideline_proposal }}
                        </h5>
                      </a>
                      <h5 v-else>
                        The link is not yet available, please update it
                      </h5>
                    </div>
                  </div>
                </v-card>
              </div>
              <!-- <div class="mb-3">
                <h4>Link for Proposal</h4>
                <h5 class="mb-1" style="font-weight: normal">Link JOTFORM</h5>
                <v-textarea
                  v-if="isEdit"
                  class="rounded-lg"
                  auto-grow
                  outlined
                  rows="2"
                  hide-details
                  dense
                  placeholder="Put the link here"
                  v-model="dataSetCover.link_form_proposal"
                ></v-textarea>
                <v-card flat outlined class="rounded-lg" v-if="!isEdit">
                  <div class="d-flex align-center justify-start">
                    <v-card
                      class="pa-3 rounded-lg d-flex justify-center align-center"
                      color="#757575"
                      flat
                      dark
                    >
                      <v-icon large>mdi-link-variant</v-icon>
                    </v-card>
                    <div class="ml-2" style="width: 85%">
                      <a
                        v-if="dataSetCover.link_form_proposal"
                        :href="dataSetCover.link_form_proposal"
                        target="_blank"
                      >
                        <h5 style="width: 100%">
                          {{ dataSetCover.link_form_proposal }}
                        </h5>
                      </a>
                      <h5 v-else>
                        The link is not yet available, please update it
                      </h5>
                    </div>
                  </div>
                </v-card>
              </div> -->
            </v-card>
            <div class="pa-3"></div>
            <v-card v-if="loading" flat class="mt-4 rounded_max pa-4">
              <v-skeleton-loader
                type="list-item-three-line, article"
              ></v-skeleton-loader>
            </v-card>
            <v-card
              v-if="!loading && !dataSetCover && !dataSetCover"
              flat
              class="mt-4 rounded-lg pa-3 align-center justify-center d-flex flex-column"
            >
              <img
                src="../../../../assets/img/redaksi/pagenotfound.png"
                height="150px"
                alt=""
              />
              <b class="default_txt mt-3">Data not found</b>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import tsaResponse from "./response/tsaResponse.vue";
export default {
  name: "tsaProposal",
  components: { tsaResponse },
  computed: {
    ...mapState({
      permissions: (state) => state.permissions,
      role: (state) => state.role,
    }),
  },
  data() {
    return {
      isEdit: false,
      loading: true,
      loadingTextCover: false,
      loadingTextProposal: false,
      tab: null,
      editLinkCover: false,
      editLinkProposal: false,
      editLinkGuidelineCover: false,
      editLinkGuidelineProposal: false,
      dataSet: null,
      dataSetCover: null,
      category: 1,
      optTypeEvent: [],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    updateData() {
      this.loading = true;
      let body = {
        id: this.category,
        link_form_proposal: this.dataSetCover.link_form_proposal,
        link_guideline_proposal: this.dataSetCover.link_guideline_proposal,
        link_form_letter: this.dataSetCover.link_form_letter,
        link_guideline_letter: this.dataSetCover.link_guideline_letter,
      };

      let data = {
        path: "tsa-proposal/admin/doc-info",
        body: body,
      };
      this.$store.dispatch("user/postApi", data).then((data) => {
        this.loading = false;
        this.isEdit = false;
        this.$store.dispatch("notify", {
          msg: data.message,
          type: "success",
        });
      });
    },

    updateProposal() {
      this.loadingTextProposal = true;
      let file = new FormData();
      file.append("id", this.dataSetCover.id);
      file.append("link_guideline", this.dataSetCover.link_guideline);
      file.append("link_form", this.dataSetCover.link_form);

      let data = {
        path: `tsa-proposal/admin/proposal-info`,
        body: file,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.editLinkProposal = false;
          this.editLinkGuidelineProposal = false;
          this.loadingTextProposal = false;
          this.fetchData();
        })
        .catch((err) => {
          this.$store.dispatch("notify", {
            msg: err.message,
            type: "error",
          });
          this.errMsg = err;
          this.loadingTextProposal = false;
        });
    },
    updateCover() {
      this.loadingTextCover = true;
      let file = new FormData();
      file.append("id", this.dataSetCover.id);
      file.append("link_guideline", this.dataSetCover.link_guideline);
      file.append("link_form", this.dataSetCover.link_form);

      let data = {
        path: `tsa-proposal/admin/letter-info`,
        body: file,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.editLinkCover = false;
          this.editLinkGuidelineCover = false;
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.loadingTextCover = false;
          this.fetchData();
        })
        .catch((err) => {
          this.$store.dispatch("notify", {
            msg: err.message,
            type: "error",
          });
          this.errMsg = err;
          this.loadingTextCover = false;
        });
    },
    linkEdited(isEditLink, type) {
      if (isEditLink) {
        if (type == "cover") {
          this.editLinkCover = true;
          this.editLinkGuidelineCover = true;
        } else {
          this.editLinkProposal = true;
          this.editLinkGuidelineProposal = true;
        }
      } else {
        if (type == "cover") {
          this.dataSetCover.link_form = "";
          this.dataSetCover.link_guideline = "";
          this.editLinkCover = true;
          this.editLinkGuidelineCover = true;
        } else {
          this.dataSetCover.link_form = "";
          this.dataSetCover.link_guideline = "";
          this.editLinkProposal = true;
          this.editLinkGuidelineProposal = true;
        }
      }
    },
    fetchData() {
      this.loading = true;
      let data = {
        path: `tsa-proposal/category`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.optTypeEvent = data;
          this.fetchDataCover();
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    fetchDataCover() {
      this.loading = true;
      this.dataSetCover = null;
      let data = {
        path: `tsa-proposal/admin/doc-info?filter[id]=${this.category}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          console.log(data);
          if (data.data.length > 0) {
            this.dataSetCover = data.data[0];
          }

          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          console.log("cover", err);
          this.$store.dispatch("notify", {
            msg: err.message,
            type: "error",
          });
        });
    },
  },
};
</script>

<style></style>
